import { useCallback, useEffect } from 'react';
import { useAppContext } from '@/context/AppContext';
import { ErrorState, ErrorActions } from '@/types';

export function useErrorHandler(): [ErrorState, ErrorActions] {
  const { state, dispatch } = useAppContext();

  const errorState: ErrorState = {
    errors: state.ui.errors,
    successMessages: state.ui.successMessages
  };

  const addError = useCallback((message: string) => {
    dispatch({ type: 'ADD_ERROR', payload: message });
  }, [dispatch]);

  const clearErrors = useCallback(() => {
    dispatch({ type: 'CLEAR_ERRORS' });
  }, [dispatch]);

  const addSuccess = useCallback((message: string) => {
    dispatch({ type: 'ADD_SUCCESS', payload: message });
  }, [dispatch]);

  const clearSuccess = useCallback(() => {
    dispatch({ type: 'CLEAR_SUCCESS' });
  }, [dispatch]);

  // Auto-clear success messages after 3 seconds
  useEffect(() => {
    if (state.ui.successMessages.length > 0) {
      const timer = setTimeout(() => {
        clearSuccess();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [state.ui.successMessages.length, clearSuccess]);

  // Auto-clear error messages after 5 seconds
  useEffect(() => {
    if (state.ui.errors.length > 0) {
      const timer = setTimeout(() => {
        clearErrors();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [state.ui.errors.length, clearErrors]);

  const errorActions: ErrorActions = {
    addError,
    clearErrors,
    addSuccess,
    clearSuccess
  };

  return [errorState, errorActions];
}
